import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import utils from '../../../utils/validateScanner.js'

export default {
	name: 'DTOAWBFlyerCheck',
	mixins: [utils],
	components: {
		VueElementLoading,
	},
	data: function() {
		return {
			shippingID: '',
			barCode: '',
			LoginHubId: '',
			isLoading: false,
			colorshippingID :''
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.LoginHubId =userdetail[0].HubId[0];
		this.$refs.shippingID.focus();
	},
	methods: {
		nextshippingID(){
			this.$nextTick(() => {
				this.$refs.barCode.focus();
			})
		},
		awbflyermatchcheck(){
			this.isLoading=true;
			this.colorshippingID = this.shippingID;
			this.input = ({
				FlyerBarcode:this.barCode,
				shippingId: this.shippingID,
				currentHubId: this.LoginHubId
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'awbflyermatchcheck',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(async result => {
				this.isLoading=false;
				if (result.data.ResultCode == 100) {
					// PXB-7142 Shipment Color Code & Icon
						if(Object.keys(result.data.lossCategorization).length !=0){
						this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
						}
						
					this.$alertify.success(result.data.ReturnMessage)
				} else {
					this.$alertify.error(result.data.ReturnMessage)
				}
				this.reset();
			}, error => {
				this.isLoading=false;
				this.$alertify.error('Error')
				console.error(error)
			})
		},

		onSubmit: function() {
			this.$validator.validateAll()
			.then((result) => {
				if (!result) {
					return false;
				} else {
					this.awbflyermatchcheck();
				}
			}).catch(() => {
				console.log('errors exist', this.errors);
			});
		},

		reset(value) {
			this.$validator.reset();
			this.shippingID = '';
			this.isLoading = false;
			this.barCode='';
			this.$refs.shippingID.focus(); 
			if(value){
				this.showHideCodeIconInput();
				this.colorshippingID = '';
			}
			
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/DTOAWBFlyerCheck/DTOAWBFlyerCheck.js